import isURL from 'validator/lib/isURL';
import React from 'react';
import { useHistory } from 'react-router';
export function Anchor({ ariaLabel, className, href, title, children, onClick, testId, tabIndex }) {
    if (!href) {
        return (React.createElement("span", { className: className, title: title, "aria-label": ariaLabel, onClick: onClick, "data-testid": testId }, children));
    }
    else if (isURL(href)) {
        return (React.createElement("a", { "aria-label": ariaLabel, className: className, href: href, title: title, target: "_blank", rel: "noopener", onClick: onClick, "data-testid": testId, tabIndex: tabIndex }, children));
    }
    else if (href.startsWith('#') || href.startsWith('mailto:')) {
        return (React.createElement("a", { className: className, href: href, title: title, "aria-label": ariaLabel, onClick: onClick, "data-testid": testId, tabIndex: tabIndex }, children));
    }
    else {
        const { createHref } = useHistory();
        return (React.createElement("a", { className: className, href: createHref({ pathname: href }), title: title, "aria-label": ariaLabel, onClick: onClick, "data-testid": testId, tabIndex: tabIndex }, children));
    }
}
//# sourceMappingURL=Anchor.js.map